import { render, staticRenderFns } from "./RegistrationMenu.vue?vue&type=template&id=e2b38a84&"
import script from "./RegistrationMenu.vue?vue&type=script&lang=js&"
export * from "./RegistrationMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports